// extracted by mini-css-extract-plugin
export default {"cardTitle":"Inventory_cardTitle__jZ8FM"};